<template>
  <transition v-cloak name="modal">
    <v-modal
      :is-open="showModal"
      data-test="quickquote-modal"
      modal-class="alt-modal"
      :space-bottom="false"
      @close="
        emitHideModal();
        resetApiErrorMessage();
        resetTitleAndContent();
      "
    >
      <template #content>
        <div v-if="showTitleAndContent">
          <h3 v-html="title" />
          <div v-if="!showQuickQuoteRuleVerificationError">
            <p
              v-if="!showQuickQuoteModalErrorValidation"
              class="push-down"
              data-test="quickquote-error-modal-content"
              v-html="content"
            />
          </div>
          <div v-else>
            <p v-html="ruleVerificationText" />
          </div>
        </div>
      </template>
      <template #buttons>
        <div class="small-12 columns">
          <call-me
            v-if="showCallMeForm"
            :datasource="callMeDatasource"
            @call-me-not-loaded="setCloseButton"
            @call-me-close="emitHideModal()"
            @call-me-step-two="hideTitleAndContent()"
          />
          <button
            v-if="showCloseButton"
            class="button secondary small-12 columns align-center"
            data-test="quickquote-modal-back-button"
            @click="
              emitHideModal();
              resetApiErrorMessage();
            "
            v-html="labelButtonClose"
          />
        </div>
      </template>
    </v-modal>
  </transition>
</template>

<script lang="ts">
import QQErrorMessage from '@/interfaces/IQQErrorMessage';
import CallMe from '@/components/Feature/CallMe/CallMe.vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'QuickQuoteErrorModal',
  components: {
    CallMe
  },
  props: {
    showModal: {
      type: Boolean,
      default() {
        return false;
      }
    },
    title: {
      type: String,
      default() {
        return '';
      }
    },
    content: {
      type: String,
      default() {
        return '';
      }
    },
    showQuickQuoteRuleVerificationError: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showQuickQuoteModalErrorValidation: {
      type: Boolean,
      default() {
        return false;
      }
    },
    ruleVerificationText: {
      type: String,
      default() {
        return '';
      }
    },
    labelButtonClose: {
      type: String,
      default() {
        return '';
      }
    },
    apiResponseError: {
      type: Array as PropType<QQErrorMessage[]>,
      default() {
        return [];
      }
    },
    callMeDatasource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      showCloseButton: false,
      showTitleAndContent: true
    };
  },
  computed: {
    showCallMeForm(): boolean {
      return this.callMeDatasource !== '';
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.$store.dispatch('Events/register', {
          event: 'quick-quote-error-modal-show',
          id: 'quickQuoteFlow',
          vm: {
            url: window.location.pathname
          }
        });
      }

      this.dispatchErrorMessage(this.apiResponseError);
    }
  },
  methods: {
    emitHideModal() {
      this.showCloseButton = false;
      this.$emit('hide-quick-quote-error-modal', true);
    },
    dispatchButtonClickEvent(value: string) {
      this.$store.dispatch('Events/register', {
        event: 'quick-quote-error-modal-button-click',
        id: 'quickQuoteFlow',
        vm: value
      });
    },
    dispatchErrorMessage(value: Array<QQErrorMessage>) {
      if (value === null || value.length == 0) {
        return;
      }

      value.forEach((error) => {
        this.$store.dispatch('Events/register', {
          event: 'quick-quote-error-modal-error-message',
          id: 'quickQuoteFlow',
          vm: error.Message
        });
      });
    },
    resetApiErrorMessage() {
      this.$emit('api-error', null);
    },
    setCloseButton() {
      this.showCloseButton = true;
    },
    hideTitleAndContent() {
      this.showTitleAndContent = false;
    },
    resetTitleAndContent() {
      this.showTitleAndContent = true;
    }
  }
});
</script>
